export default "__VITE_ASSET__cbd5cf63__"